import { useEffect, useRef } from "react";
import * as THREE from "three";
import { cloneAndScaleUV } from "./geometryUltis";

export default function useGateBoundingDataChecker({ nodes, gate, onBoundingDataChanged, group }) {
  const lastBoundingDataRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        nodes?.Door_Frame?.geometry &&
        nodes?.Mesh003?.geometry &&
        nodes?.Mesh003_1?.geometry &&
        gate.type === 'double_leaf_gate'
      ) {
        const scaledDoorFrameGeometry = cloneAndScaleUV(
          nodes.Door_Frame.geometry, 1,
          gate.height / 100, gate.width / 100, gate.width / 100, gate.height / 100
        );
        const scaledMesh003Geometry = cloneAndScaleUV(
          nodes.Mesh003.geometry, 1,
          gate.height / 100, gate.width / 100, gate.width / 100, gate.height / 100
        );
        const scaledMesh0031Geometry = cloneAndScaleUV(
          nodes.Mesh003_1.geometry, 1,
          gate.height / 100, gate.width / 100, gate.width / 100, gate.height / 100
        );

        const tempGroup = new THREE.Group();
        tempGroup.add(
          new THREE.Mesh(scaledDoorFrameGeometry),
          new THREE.Mesh(scaledMesh003Geometry),
          new THREE.Mesh(scaledMesh0031Geometry)
        );

        const box = new THREE.Box3().setFromObject(tempGroup);
        const size = new THREE.Vector3();
        const center = new THREE.Vector3();
        box.getSize(size);
        box.getCenter(center);

        const newBoundingData = { box, size, center };

        const boundingDataEquals = (a, b) => {
          if (!a || !b) return false;
          return (
            a.size.distanceTo(b.size) < 1e-5 &&
            a.center.distanceTo(b.center) < 1e-5
          );
        };

        if (
          gate.boundingData == null ||
          !boundingDataEquals(gate.boundingData, newBoundingData) ||
          lastBoundingDataRef.current == null ||
          !boundingDataEquals(lastBoundingDataRef.current, newBoundingData)
        ) {
          // Pure trigger → delegate decision to parent
          onBoundingDataChanged(newBoundingData);
          lastBoundingDataRef.current = newBoundingData;
        }
      } else if (gate.type === 'swing_gate' || gate.type === 'sectional_gate' || gate.type === 'roller_gate' || gate.type === 'hole_gate') {
        if (group) {
          // Calculate bounding box from the group
          const box = new THREE.Box3().setFromObject(group.current);
          const size = new THREE.Vector3();
          const center = new THREE.Vector3();
          box.getSize(size);
          box.getCenter(center);

          const newBoundingData = { box, size, center };

          const boundingDataEquals = (a, b) => {
            if (!a || !b) return false;

            if (
              !(a.size instanceof THREE.Vector3) || !(b.size instanceof THREE.Vector3) ||
              !(a.center instanceof THREE.Vector3) || !(b.center instanceof THREE.Vector3)
            ) {
              return false;
            }

            return (
              a.size.distanceTo(b.size) < 1e-5 &&
              a.center.distanceTo(b.center) < 1e-5
            );
          };

          if (
            gate.boundingData == null ||
            !boundingDataEquals(gate.boundingData, newBoundingData) ||
            lastBoundingDataRef.current == null ||
            !boundingDataEquals(lastBoundingDataRef.current, newBoundingData)
          ) {
            onBoundingDataChanged(newBoundingData);
            lastBoundingDataRef.current = newBoundingData;
          }
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [nodes, gate.height, gate.width, gate.boundingData, onBoundingDataChanged]);
}
